export function getCopayFields() {
  return ['admission_range', 'duration', 'copay', 'days_remaining'];
}
